export default "__VITE_ASSET__a1942441__"